import {THAI_PHONE_PREFIX} from 'constants/index';

export const phoneDisplayFormat = (number: string) => {
  if (!number) {
    return '';
  }
  if (number.startsWith(THAI_PHONE_PREFIX)) {
    return number.replace(THAI_PHONE_PREFIX, '0');
  } else {
    return number;
  }
};
